<div class="page-layout carded fullwidth" >
  <mat-drawer-container class="overlay-container page-layout carded fullwidth" >

    <filtros [(filtro)]="filterForm" [estados]="estados" (loadData)="loadData()" (filterChange)="filterForm=$event"></filtros>
    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT HEADER -->
      <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
          <h2 class="m-0">{{titulo}}</h2>
      </div>
      <!-- / CONTENT HEADER -->

      <!-- CONTENT CARD -->
      <div class="content-card">

          <!-- / CONTENT TOOLBAR -->

          <!-- CONTENT -->
          <div class="content p-24">
              <mat-tab-group  dynamicHeight>

              
                <mat-tab label="Preiniciadas">
                   <evaluaciones-list (printMethod)="print($event[0])" [filterForm]="filterForm" estado="PRE_INICIADO" 
                   [deleteable]="deleteable" [editable]="editable"  [imprimible]="imprimible" ></evaluaciones-list>
                </mat-tab>

                <mat-tab label="Iniciadas" >
                  <evaluaciones-list (printMethod)="print($event[0])" [filterForm]="filterForm" estado="INICIADO" 
                  [deleteable]="deleteable" [editable]="editable"  [imprimible]="imprimible" ></evaluaciones-list>
                </mat-tab>

                <mat-tab label="Completadas">
                  <evaluaciones-list (printMethod)="print($event[0])" [filterForm]="filterForm" estado="COMPLETADO"
                  [deleteable]="deleteable" [editable]="editable"  [imprimible]="imprimible" ></evaluaciones-list>

                </mat-tab>

                <mat-tab label="Aprobadas">
                  <evaluaciones-list (printMethod)="print($event[0])" [filterForm]="filterForm" estado="APROBADO"
                  [deleteable]="deleteable" [editable]="editable"  [imprimible]="imprimible" ></evaluaciones-list>
                </mat-tab>

                <mat-tab label="Cerradas">
                  <evaluaciones-list (printMethod)="print($event[0])" [filterForm]="filterForm" estado="CERRADO"
                  [deleteable]="deleteable" [editable]="editable"  [imprimible]="imprimible" ></evaluaciones-list>
                </mat-tab>

                </mat-tab-group>
              
          </div>
          <!-- / CONTENT -->

      </div>
      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </mat-drawer-container>
</div>
